import { API_URL, API_PAPU_URL }  from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type':'application/json'
    }
})

/**
 * Clase para ver el request de artículos
 */
class PedidosRequest {
    /**
     * Llamada el endpoint de django para categorizar un artículo y guardar su
     * configuración en la BD
     * @param: value. id de categoría
     * @param: data. una lista de objetos que contiene los artículos
     * @return: Mensaje de éxito o error.
     */
    static ListarArticulosGenerarPedido(value, value2) {
        let url = `api/generar-pedido/?categoria=${value}`
        if (value2) {
            url += `&drive_id=${value2}`
        }
        return middleware.hasAuth(() => request.get(url))
    }

    /**
     * Llamada el endpoint de django para categorizar un artículo y guardar su
     * configuración en la BD
     * @param: value. id de categoría
     * @param: data. una lista de objetos que contiene los artículos
     * @return: Mensaje de éxito o error.
     */
    static ListarSitiosSupervisor() {
        return middleware.hasAuth(() => request.get(`api/usuarios/detalle/`))
    }
    

    /**
     * Llamada el endpoint de django para categorizar un artículo y guardar su
     * configuración en la BD
     * @param: value. id de categoría
     * @param: data. una lista de objetos que contiene los artículos
     * @return: Mensaje de éxito o error.
     */
    static GenerarPedido(value, data) {
        return middleware.hasAuth(() => request.post(`api/generar-pedido/?categoria=${value}`, data))
    }

    /* ----------------------------------------------------------------------------- */

    /**
     * Llamada el endpoint de django para crear un pedido y guardarlo
     * en la base de datos
     * @param: obj. Los datos que se envían para generar un pedido
     * @return: Mensaje de éxito o error.
     */
    static RealizarPedido(obj) {
        return middleware.hasAuth(() => request.post(`${API_PAPU_URL}/api/pedidos/`, obj))
    }

    /**
     * Llamada el endpoint de django para obtener los pedidos por sitio y filtros
     * en la BD
     * @param: nada
     * @return: Una lista de pedidos por sitio.
     */
    static CargarPedidosSitio(value, filtros) {
        let url = `${API_PAPU_URL}/api/pedido_por_sitio/${value}`;
        if (filtros !== undefined) {
            url = `${API_PAPU_URL}/api/pedido_por_sitio/${value}?` + ((filtros.page === null || filtros.page === undefined) ? `page=1` : `page=${filtros.page}`) + (filtros.texto_busqueda === null ? '' : `&texto_busqueda=${filtros.texto_busqueda}`) + (filtros.estatus === null ? '' : `&estatus_filtrado=${filtros.estatus}`) + (filtros.dateInicioPedido === null ? '' : `&fecha_inferior_realizado=${filtros.dateInicioPedido}`) + (filtros.dateFinPedido === null ? '' : `&fecha_superior_realizado=${filtros.dateFinPedido}`) + (filtros.dateInicioVencimiento === null ? '' : `&fecha_inferior_vencimiento=${filtros.dateInicioVencimiento}`) + (filtros.dateFinVencimiento === null ? '' : `&fecha_superior_vencimiento=${filtros.dateFinVencimiento}`)
        }

        return middleware.hasAuth(() => request.get(url));
    }

    /**
     * Llamada el endpoint de django para obtener los pedidos realizados
     * en la BD
     * @param: nada
     * @return: Una lista de pedidos realizados.
     */
    static CargarArticulosPedido(value) {
        return middleware.hasAuth(() => request.get(`${API_PAPU_URL}/api/pedido/${value}/`));
    }

    /**
     * Llamada el endpoint de django para obtener los pedidos realizados
     * en la BD
     * @param: nada
     * @return: Una lista de pedidos realizados.
     */
    static CargarArticulosPedidoPag(Id, page = undefined, recibir = false, pageSize = undefined) {
        return middleware.hasAuth(() => {
            const params = {
                'id_pedido': Id,
                'recibir': recibir,
            };
    
            // Esta condición asegura que 'page' solo se añade si se le dio un valor
            if (page !== undefined) {
                params['page'] = page;
            }
    
            // Esta condición es la clave:
            // 'page_size' SÓLO se añade a 'params' si 'pageSize' NO es 'undefined'
            if (pageSize !== undefined) {
                params['page_size'] = pageSize;
            }
    
            return request.get(`api/pedido-detalle`, {
                params: params
            });
        });
    }

    /**
     * Llamada el endpoint de django para obtener los estatus de los pedidos
     * en la BD
     * @param: nada
     * @return: Una lista de estatus de pedidos
     */
    static CargarEstatusPedido(value) {
        return middleware.hasAuth(() => request.get('api/estatus-pedido'));
    }

    /**
     * Método que consume el endpoint que realiza la planeación de un pedido
     * @param {Object} obj : objeto con el ID del pedido, art planeados y art abiertos 
     * @return {} :
     */
    static PlanearPedido(obj) {
        return middleware.hasAuth(() => request.put(`${API_PAPU_URL}/api/planear_pedido/${obj.sitio}`, obj));
    }

    /**
     * Método que consume el endpoint que lista los artículos de un pedido
     */
    static ArticulosEmbarcar(value) {
        return middleware.hasAuth(() => request.get(`${API_PAPU_URL}/api/pedidos/embarcar/${value}`));
    }
    /**
     * Método que consume el endpoint que trae los lotes de un articulo de un pedido
     */
    static ObtenerLotes(pedido_id, articulo_id) {
        return middleware.hasAuth(() => request.get(`${API_PAPU_URL}/api/pedidos/lotes/${pedido_id}/${articulo_id}`));
    }
    /**
     * Método que consume el endpoint que realiza la embarcación de un pedido
     * @param {Object} obj : objeto con los artículos a embarcar
     * @return {} :
     */
    static EmbarcarPedido(value, obj) {
        return middleware.hasAuth(() => request.put(`${API_PAPU_URL}/api/embarcar_pedido/${value}/`, obj));
    }

    /**
     * Método que consume el endpoint que cancela el pedido
     * en pedidos realizados
     */
    static CancelarPedido(pedido_id, data) {

        return middleware.hasAuth(() => request.put(`${API_URL}api/cancelar-pedido/?pedido_id=${pedido_id}`, data));
    }

    /**
     * Método que consume el endpoint que lista los proveedores adicionales de un sitio
     */
    static ProveedoresAdicionalesSitio(value) {
        return middleware.hasAuth(() => request.get(`${API_PAPU_URL}/api/obtener_proveedores_adicionales/${value}`));
    }

    /**
     * Método que consume el endpoint que lista los proveedores adicionales de un sitio
     */
    static InventarioProveedoresAdicionales(data) {
        return middleware.hasAuth(() => request.post(`${API_PAPU_URL}/api/inventario_proveedores_adicionales/`, data));
    }

    /**
     * Método que consume el endpoint que crea un envío directo
     */
    static DelegarPedido(data) {
        return middleware.hasAuth(() => request.post(`${API_PAPU_URL}/api/pedidos/delegar_pedido/`, data));
    }

    /**
     * Método para obtener información adicional al pedido al momento de imprimir
     * su detalle en un archivo excel
     * @param {String} no_pedido : string que representa el número de pedido del cual obtener la información.
     * @return {} :
     */
    static DetallePedidoImpresion(no_pedido) {
        return middleware.hasAuth(() => request.get(`${API_PAPU_URL}/api/pedidos/detalle_impresion/`, {
            params: {
                numero_pedido: no_pedido
            }
        }))
    }

    /**
     * Método para obtener los pedidos delegados del sitio seleccionado
     * @param {String} no_pedido : string que representa el número de pedido del cual obtener la información.
     * @return {} :
     */
    static CargarPedidosDelegados(no_pedido) {
        return middleware.hasAuth(() => request.get(`${API_PAPU_URL}/api/pedidos/monitoreo_pedidos_delegados`, {
            params: {
                id_conf_sitio: no_pedido
            }
        }))
    }

    /**
     * Llamada al endpoint para traer los consolidados que existen dentro de la 
     * BD.
     * @param {Object} obj : objeto que contiene los filtros para los consolidados
     * @return {} :
     */
    static CargarPedidosRealizados(value, obj = undefined, categoria) {
        return middleware.hasAuth(() => request.get(`/api/lista-pedidos/`,
            {
                params: {
                    'busqueda': obj ? obj.busqueda : undefined,
                    'estatus_filtrado': obj ? obj.estatus : undefined,
                    'fecha_inferior_realizado': obj ? obj.dateInicioPedido : undefined,
                    'fecha_superior_realizado': obj ? obj.dateFinPedido : undefined,
                    'fecha_inferior_vencimiento': obj ? obj.dateInicioVencimiento : undefined,
                    'fecha_superior_vencimiento': obj ? obj.dateFinVencimiento : undefined,
                    'page': obj ? obj.page : undefined,
                    'categoria': categoria,
                    'id_sitio': value
                }
            }
        ));
    }

    /**
     * Método que consume el endpoint que cancela el artículo de un pedido
     * en pedidos realizados
     */
    static CancelarArticuloPedido(value) {
        return middleware.hasAuth(() => request.put(`${API_PAPU_URL}/api/pedidos/cancelar_articulo/${value}/`));
    }

    /**
     * Método que consume el endpoint que lista los artículos embarcados de un pedido
     */
    static CargarArticulosEmbarcados(value, obj, page) {
        return middleware.hasAuth(() => request.get(`${API_PAPU_URL}/api/pedidos/articulos/recibir/${value}`, {
            params: {
                page: page
            }
        }));
    }

    /**
     * Método que consume el endpoint que realiza la recepción de un pedido
     * @param {Object} obj : objeto con los artículos a recibir
     * @return {} :
     */
    static RecibirPedido(obj) {
        return middleware.hasAuth(() => request.post(`${API_URL}api/recibir-pedido/?pedido_id=${obj.pedido}/`, obj));
    }

    /**
     * Método que consume el endpoint que realiza la recepción de un artículo
     * @param {Object} obj : id del artículo a recibir
     * @param {Object} value : true o false 
     * @return {} :
     */
    static RecibirArticulo(obj, value) {
        return middleware.hasAuth(() => request.put(`${API_PAPU_URL}/api/pedidos/recibir-incompletos/${obj}/`, value));
    }

    /**
     * Método que consume el endpoint que lista los artículos pendientes de un pedido
     * embarcado incompleto
     */
    static CargarArticulosPendientes() {
        return middleware.hasAuth(() => request.get(`${API_PAPU_URL}/api/reportes/articulos_pendientes/`));
    }

    /**
     * Método que consume el endpoint que califica el pedido
     * en pedidos realizados
     */
    static CalificarPedidoRealizado(pedido_id, data) {
        return middleware.hasAuth(() => request.post(`${API_URL}api/calificar-servicio/?pedido_id=${pedido_id}`, data));
    }

    /**
     * Método que consume el endpoint que obtiene información de las TR's del pedido
     */
    static CargarInformacionTR(value) {
        return middleware.hasAuth(() => request.get(`${API_PAPU_URL}/api/transferencias/?pedido_id=${value}`));
    }

    /**
     * Método para reenviar el pedido a sap.
     */
    static EnviarPedidoSAP(pedido_id) {
        return middleware.hasAuth(() => request.post(`${API_URL}api/reenviar-pedido/?pedido_id=${pedido_id}`));
    }

    /**
     * Método para reenviar la devolución a sap.
     */
    static ReenviarDevolucionSAP(pedido_id) {
        return middleware.hasAuth(() => request.post(`${API_URL}api/reenviar-devolucion/?pedido_id=${pedido_id}`));
    }

    /**
     * Método que consume el endpoint que reenvia el recibir el pedido
     */
    static ReenviarRecibirPedido(pedido_id) {
        return middleware.hasAuth(() => request.post(`${API_URL}api/reenviar-recibir-pedido/?pedido_id=${pedido_id}`));
    }

    /**
     * Método para reenviar la devolución a sap.
     */
    static ReenviarConfirmaciónDevolucionSAP(pedido_id) {
        return middleware.hasAuth(() => request.post(`${API_URL}api/reenviar-confirmacion-devolucion/?pedido_id=${pedido_id}`));
    }

    /**
     * Método que consume el endpoint que cancela el artículo de un pedido
     */
    static CancelarArticuloSAP(articulo_id) {
        return middleware.hasAuth(() => request.delete(`${API_URL}api/cancelar-articulo/?articulo_id=${articulo_id}`));
    }

    /**
     * Método que consume el endpoint que actualiza las cantidades de los artículos de un pedido
     */
    static ActualizarArticulosSAP(obj) {
        return middleware.hasAuth(() => request.put(`${API_URL}api/actualizar-articulos/?pedido_id=${obj.pedido}/`, obj));
    }
}

export default PedidosRequest;